export class LocationNameModel {
    chargePointLocationId: number;
    name: string;
    display : string;
    value : number;
}
